import getClientsMin from './getClientsMin'
import item from './item'

export const getClientsMinService = getClientsMin
export const itemService = item
